// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2ozlA","row":"Node_row__y-Xfd","label":"Node_label__CqnjU","footer":"Node_footer__2LJKc"};